import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private route: Router, private location: Location, private toastr: ToastrService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            catchError(err => {

                if (this.checkSpecificRequestsToRedirect(req.url)) {

                    const lang = window.location.pathname.split('/')[1];

                    this.route.navigate([`/${lang}/erro`], { 
                        queryParams: { 
                            returnUrl: this.createReturnUrl() 
                        }
                    });

                } else if (this.checkCasesToShowToast(req.url)) {

                    this.toastr
                        .error('Ocorreu um erro inesperado. Tente novamente, ou atualize a página. Caso o erro persista contate o suporte.', 
                            null,
                            {
                                closeButton: true,
                                disableTimeOut: false
                            });

                }

                throw err;

            })
        );
    }

    private createReturnUrl(): string {
        const url = this.location.path(false);
        return window.encodeURI(url);
    }

    private checkSpecificRequestsToRedirect(url: string): boolean {

        const validatorUrls = ['auth', 'professores'];

        for (const key in validatorUrls) {
            if (Object.prototype.hasOwnProperty.call(validatorUrls, key)) {
                const item = validatorUrls[key];
                if (url.indexOf(item) > -1 && 
                    (window.location.href.indexOf('returnUrl') === -1)
                    ) {
                    return true;
                }
            }
        }

        return false;
    }

    private checkCasesToShowToast(url: string): boolean {
        return this.location.path(false).indexOf('erro') == -1 && url.indexOf('assets') == -1;
    }
}
